import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoStoreFn = /* @__PURE__ */ createRecipe('logo-store', {}, [])

const logoStoreVariantMap = {}

const logoStoreVariantKeys = Object.keys(logoStoreVariantMap)

export const logoStore = /* @__PURE__ */ Object.assign(memo(logoStoreFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoStore',
  __getCompoundVariantCss__: logoStoreFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoStoreVariantKeys,
  variantMap: logoStoreVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoStoreVariantKeys)
  },
  getVariantProps: logoStoreFn.getVariantProps,
})